var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 269,
    viewBox: "0 0 266 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.5 230.92C228.101 236.603 222.993 240.269 218.957 243.165C171.514 277.205 115.377 267.283 103.446 264.859C85.8279 261.281 51.7727 254.364 27.1514 225.41C-10.0986 181.605 -4.29819 112.591 24.5954 67.0341C29.8805 58.701 57.7979 12.45 114.54 5.03277C148.88 0.543996 188.908 9.59739 217.896 33.8834C278.745 84.8621 274.413 187.848 233.5 230.92Z",
    fill: "url(#paint0_linear_6095_172455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238.302 267.667H27.7942C13.2356 267.667 1.43359 255.865 1.43359 241.307V178.502H264.663V241.307C264.663 255.865 252.861 267.667 238.302 267.667Z",
    fill: "url(#paint1_linear_6095_172455)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.48 64.0354C183.453 63.1205 182.29 62.3676 180.865 62.3676H126.988C125.544 62.3676 124.125 63.1597 124.125 64.0871V146.977C124.125 147.423 124.525 147.851 125.017 148.166C125.509 148.481 126.238 148.658 126.933 148.657L183.264 148.558C183.965 148.557 184.651 148.375 185.142 148.053C185.632 147.731 185.908 147.287 185.895 146.837L183.48 64.0354Z",
    fill: "#91B3FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.802 72.1351L128.454 72.1219L128.332 67.0712H143.695L143.802 72.1351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.004 72.1326L145.671 72.1194L145.566 67.0712H160.914L161.004 72.1326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.191 72.13L162.873 72.1168L162.785 67.0712H178.117L178.191 72.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.993 81.1993L128.672 81.2056L128.551 76.1878L143.887 76.1837L143.993 81.1993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.169 81.194L145.862 81.2004L145.758 76.1851L161.079 76.181L161.169 81.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.324 81.187L163.033 81.1933L162.945 76.1806L178.251 76.1765L178.324 81.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.185 90.2011L128.89 90.2114L128.77 85.211L144.079 85.203L144.185 90.2011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.329 90.1932L146.05 90.2035L145.945 85.2055L161.24 85.1975L161.329 90.1932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.457 90.1816L163.193 90.1919L163.105 85.1965L178.384 85.1885L178.457 90.1816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.377 99.1716L129.109 99.186L128.988 94.2029L144.271 94.1908L144.377 99.1716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.49 99.161L146.237 99.1753L146.133 94.1947L161.4 94.1826L161.49 99.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.587 99.1451L163.349 99.1594L163.262 94.1813L178.514 94.1692L178.587 99.1451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.565 108.111L129.323 108.13L129.203 103.164L144.46 103.148L144.565 108.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.65 108.098L146.424 108.116L146.32 103.153L161.562 103.137L161.65 108.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.717 108.078L163.505 108.096L163.418 103.135L178.644 103.119L178.717 108.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.753 117.02L129.538 117.042L129.418 112.094L144.648 112.074L144.753 117.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.807 117.004L146.607 117.026L146.504 112.08L161.719 112.06L161.807 117.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.846 116.979L163.661 117.001L163.574 112.058L178.774 112.038L178.846 116.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.941 125.898L129.752 125.924L129.633 120.993L144.837 120.969L144.941 125.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.968 125.88L146.794 125.906L146.691 120.977L161.88 120.953L161.968 125.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.976 125.851L163.817 125.877L163.73 120.95L178.904 120.926L178.976 125.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.129 134.746L129.967 134.776L129.848 129.861L145.025 129.834L145.129 134.746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.125 134.725L146.977 134.755L146.875 129.842L162.037 129.815L162.125 134.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.106 134.691L163.973 134.721L163.887 129.811L179.034 129.784L179.106 134.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.318 143.563L130.181 143.597L130.062 138.699L145.214 138.668L145.318 143.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.283 143.539L147.161 143.573L147.059 138.678L162.195 138.646L162.283 143.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.236 143.502L164.129 143.535L164.043 138.642L179.164 138.611L179.236 143.502Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3873 70.3835C55.3723 69.5825 54.7185 68.9379 53.9173 68.9379H5.31896C4.50698 68.9379 3.64453 69.6024 3.64453 70.4144V183.834C3.64453 184.44 3.98783 185.021 4.41698 185.449C4.84613 185.877 5.47906 186.117 6.08519 186.115L55.2159 185.981C55.8272 185.979 56.425 185.732 56.8526 185.295C57.2803 184.858 57.5211 184.267 57.5096 183.655L55.3873 70.3835Z",
    fill: "#BDD0FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4758 76.9758L11.5781 76.9208L11.5841 74.9316L27.464 74.9818L27.4758 76.9758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5216 84.3023L11.5586 84.2295L11.5645 82.224L27.5096 82.2919L27.5216 84.3023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5642 91.6893L11.5352 91.5984L11.5412 89.5764L27.552 89.6624L27.5642 91.6893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6072 99.1379L11.5117 99.0285L11.5179 96.9897L27.595 97.0941L27.6072 99.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6545 106.648L11.4922 106.52L11.4983 104.464L27.6424 104.587L27.6545 106.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7434 121.859L11.4453 121.692L11.4515 119.602L27.731 119.763L27.7434 121.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.881 145.159L11.375 144.933L11.3814 142.789L27.8682 143.01L27.881 145.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6988 114.222L11.4688 114.074L11.475 112.001L27.6864 112.143L27.6988 114.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7887 129.56L11.4219 129.374L11.4281 127.266L27.7761 127.447L27.7887 129.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8346 137.327L11.3984 137.121L11.4048 134.995L27.822 135.195L27.8346 137.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9281 153.059L11.3516 152.812L11.358 150.65L27.9151 150.891L27.9281 153.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9757 161.027L11.3281 160.759L11.3346 158.578L27.9627 158.84L27.9757 161.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.024 169.063L11.3047 168.774L11.3112 166.574L28.0108 166.858L28.024 169.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0728 177.169L11.2812 176.858L11.2878 174.639L28.0595 174.944L28.0728 177.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3194 77.0479L32.322 76.9926L32.3047 74.9972L48.284 75.0477L48.3194 77.0479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4482 84.3977L32.3846 84.3244L32.3672 82.3126L48.4127 82.3809L48.4482 84.3977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5815 91.8086L32.4511 91.7171L32.4336 89.6886L48.5457 89.7751L48.5815 91.8086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7115 99.2812L32.5138 99.1712L32.4961 97.1259L48.6753 97.2308L48.7115 99.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8459 106.816L32.5803 106.687L32.5625 104.625L48.8094 104.749L48.8459 106.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1165 122.077L32.7134 121.909L32.6953 119.812L49.0793 119.974L49.1165 122.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5267 145.456L32.9131 145.229L32.8945 143.077L49.4886 143.3L49.5267 145.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9809 114.415L32.6469 114.267L32.6289 112.187L48.9441 112.33L48.9809 114.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2527 129.804L32.78 129.617L32.7617 127.502L49.2152 127.684L49.2527 129.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3893 137.597L32.8466 137.389L32.8281 135.256L49.3516 135.458L49.3893 137.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6685 153.383L32.9836 153.135L32.9648 150.965L49.6301 151.208L49.6685 153.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8072 161.378L33.0502 161.108L33.0312 158.92L49.7684 159.184L49.8072 161.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9503 169.443L33.1207 169.151L33.1016 166.944L49.9113 167.23L49.9503 169.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0941 177.577L33.1912 177.264L33.1719 175.037L50.0546 175.345L50.0941 177.577Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.534 104.486C223.015 101.321 221.928 98.0076 221.674 94.4C221.036 85.3102 226.32 76.9395 230.202 69.1133C233.769 61.9204 236.421 51.2023 224.383 52.1561C214.792 52.916 203.516 62.4741 202.23 72.4408C200.707 84.2369 206.45 99.1122 199.641 109.827C190.117 124.817 183.246 121.382 183.246 146.678C183.246 157.487 189.233 163.449 196.091 166.733C206.914 171.916 219.82 169.821 228.444 161.476C236.063 154.103 240.593 143.504 239.061 132.862C237.513 122.115 229.084 113.965 224.534 104.486Z",
    fill: "#7D97F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.486 185.959C216.271 185.959 216.076 185.814 216.022 185.596C210.052 161.77 206.803 140.17 206.364 121.397C206.013 106.359 207.453 93.0857 210.646 81.9468C216.106 62.8969 224.689 56.766 225.052 56.5144C225.269 56.364 225.567 56.4176 225.717 56.6345C225.868 56.8512 225.815 57.1495 225.598 57.3006C225.512 57.3609 216.883 63.5561 211.53 82.3374C206.579 99.7068 203.501 131.68 216.95 185.363C217.015 185.62 216.859 185.88 216.602 185.944C216.563 185.954 216.524 185.959 216.486 185.959Z",
    fill: "#91B3FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.089 77.8192C233.625 77.6934 233.115 77.6542 232.573 77.7165C229.573 78.0615 228.34 81.2256 227.459 83.6994C226.704 85.8179 225.814 88.3893 226.26 90.6844C226.742 93.1658 229.377 95.1899 231.289 92.6705C233.463 89.8068 236.724 85.41 236.744 81.615C236.754 79.7287 235.695 78.2548 234.089 77.8192Z",
    fill: "#91B3FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M265.563 149.421C266.79 141.337 263.852 132.055 262.385 123.505C261.61 118.985 261.251 114.499 261.977 109.945C262.699 105.417 264.827 100.52 262.865 96.0087C258.912 86.9204 249.516 91.0564 244.133 97.8983C237.887 105.838 236.18 118.812 233.807 128.802C232.377 134.825 230.223 141.002 229.468 147.139C228.219 157.306 230.517 164.365 235.381 169.131C240.046 173.704 247.15 174.652 252.857 171.474C258.012 168.603 263.583 162.464 265.563 149.421Z",
    fill: "#91B3FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.065 187.101C243.835 187.101 243.633 186.935 243.593 186.702C243.572 186.579 241.527 174.237 241.474 157.21C241.424 141.487 243.11 118.43 251.424 97.8747C251.522 97.6299 251.8 97.5107 252.047 97.6105C252.292 97.7096 252.41 97.9887 252.311 98.2338C244.058 118.639 242.383 141.556 242.431 157.188C242.483 174.142 244.517 186.421 244.537 186.543C244.581 186.803 244.405 187.05 244.145 187.094C244.118 187.099 244.091 187.101 244.065 187.101Z",
    fill: "#7D97F4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M128.989 41.4986C128.956 39.7641 127.541 38.3368 125.806 38.3368H60.2309C58.4728 38.3368 56.7461 39.8386 56.7461 41.5967V198.738C56.7461 199.584 57.2334 200.395 57.8322 200.992C58.4312 201.589 59.3184 201.924 60.1642 201.921L128.727 201.734C129.58 201.732 130.415 201.387 131.012 200.777C131.608 200.168 131.945 199.325 131.929 198.472L128.989 41.4986Z",
    fill: "#7D97F4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6963 56.854L62.0154 56.8289L61.8672 47.2538H80.5663L80.6963 56.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.634 56.8492L82.9716 56.8241L82.8438 47.2538H101.524L101.634 56.8492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.552 56.8443L103.908 56.8193L103.801 47.2538H122.462L122.552 56.8443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9289 74.0375L62.2804 74.0494L62.1328 64.5368L80.7993 64.5292L80.9289 74.0375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.831 74.0275L83.2017 74.0394L83.0742 64.5317L101.722 64.5239L101.831 74.0275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.714 74.0141L104.103 74.026L103.996 64.523L122.625 64.5153L122.714 74.0141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1616 91.1029L62.5457 91.1225L62.3984 81.6428L81.0325 81.6276L81.1616 91.1029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.029 91.0879L83.4317 91.1074L83.3047 81.6326L101.92 81.6172L102.029 91.0879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.873 91.0659L104.294 91.0855L104.188 81.6153L122.784 81.6L122.873 91.0659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3944 108.109L62.8108 108.136L62.6641 98.6896L81.2657 98.6666L81.3944 108.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 108.089L83.6578 108.116L83.5312 98.6742L102.114 98.6512L102.223 108.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.036 108.059L104.489 108.086L104.383 98.6484L122.947 98.6255L123.036 108.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6273 125.057L63.0758 125.091L62.9297 115.677L81.499 115.647L81.6273 125.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.421 125.032L83.8878 125.066L83.7617 115.657L102.312 115.626L102.421 125.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.194 124.993L104.68 125.027L104.574 115.623L123.106 115.592L123.194 124.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8563 141.946L63.3372 141.988L63.1914 132.606L81.7286 132.568L81.8563 141.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.615 141.916L84.1139 141.958L83.9883 132.581L102.507 132.543L102.615 141.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.354 141.869L104.871 141.911L104.766 132.538L123.266 132.5L123.354 141.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0856 158.797L63.5983 158.847L63.4531 149.498L81.9581 149.452L82.0856 158.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.809 158.742L84.34 158.791L84.2148 149.447L102.701 149.401L102.809 158.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.509 158.686L105.058 158.736L104.953 149.396L123.421 149.35L123.509 158.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.315 175.574L63.8596 175.631L63.7148 166.313L82.188 166.261L82.315 175.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.003 175.51L84.5661 175.567L84.4414 166.254L102.896 166.202L103.003 175.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.668 175.446L105.25 175.503L105.145 166.195L123.581 166.142L123.668 175.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5404 192.293L64.1169 192.357L63.9727 183.072L82.4139 183.011L82.5404 192.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19 192.221L84.7845 192.285L84.6602 183.004L103.083 182.944L103.19 192.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.824 192.149L105.437 192.213L105.332 182.937L123.737 182.877L123.824 192.149Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M180.713 65.637C195.791 65.637 208.015 53.4133 208.015 38.3345C208.015 23.2557 195.791 11.032 180.713 11.032C165.634 11.032 153.41 23.2557 153.41 38.3345C153.41 53.4133 165.634 65.637 180.713 65.637Z",
    fill: "url(#paint2_linear_6095_172455)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.711 64.7292C195.288 64.7292 207.106 52.9119 207.106 38.3345C207.106 23.7571 195.288 11.9398 180.711 11.9398C166.134 11.9398 154.316 23.7571 154.316 38.3345C154.316 52.9119 166.134 64.7292 180.711 64.7292Z",
    fill: "url(#paint3_linear_6095_172455)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M156.381 37.3203C156.376 37.3203 156.371 37.3203 156.366 37.3201C156.212 37.3119 156.094 37.1806 156.102 37.027C156.156 35.9901 156.277 34.9487 156.46 33.9316C156.487 33.7802 156.631 33.6794 156.784 33.7066C156.936 33.7341 157.036 33.879 157.009 34.0306C156.83 35.0246 156.712 36.0425 156.659 37.0558C156.651 37.2049 156.528 37.3203 156.381 37.3203Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M158.947 27.6489C158.904 27.6489 158.862 27.6394 158.821 27.6189C158.684 27.5495 158.629 27.3817 158.698 27.2445C162.918 18.884 171.353 13.6903 180.712 13.6903C182.204 13.6903 183.7 13.8248 185.157 14.0907C185.309 14.1181 185.409 14.2633 185.382 14.415C185.354 14.5667 185.209 14.6679 185.057 14.6392C183.633 14.3796 182.171 14.2481 180.712 14.2481C171.565 14.2481 163.321 19.3245 159.196 27.4957C159.147 27.5928 159.049 27.6489 158.947 27.6489Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M197.081 54.7071C205.805 45.9829 205.805 31.8382 197.081 23.114C188.357 14.3898 174.212 14.3898 165.488 23.114C156.764 31.8382 156.764 45.9829 165.488 54.7071C174.212 63.4313 188.357 63.4313 197.081 54.7071Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.716 42.7782C186.397 42.7782 191.003 38.1728 191.003 32.4917C191.003 26.8106 186.397 22.2052 180.716 22.2052C175.035 22.2052 170.43 26.8106 170.43 32.4917C170.43 38.1728 175.035 42.7782 180.716 42.7782Z",
    fill: "url(#paint4_linear_6095_172455)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.987 31.55H180.719H170.433C170.433 31.55 169.614 37.4546 178.795 53.093C179.195 53.7754 179.927 54.2806 180.718 54.281C181.509 54.2813 182.242 53.7341 182.643 53.0517C191.823 37.412 190.987 31.55 190.987 31.55Z",
    fill: "url(#paint5_linear_6095_172455)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M186.619 33.4086C187.144 30.1705 184.946 27.1196 181.707 26.594C178.469 26.0685 175.418 28.2675 174.893 31.5055C174.367 34.7436 176.566 37.7945 179.804 38.3201C183.042 38.8456 186.093 36.6466 186.619 33.4086Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.146 122.446C227.225 122.446 239.449 110.222 239.449 95.1437C239.449 80.0649 227.225 67.8412 212.146 67.8412C197.068 67.8412 184.844 80.0649 184.844 95.1437C184.844 110.222 197.068 122.446 212.146 122.446Z",
    fill: "url(#paint6_linear_6095_172455)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.145 121.538C226.722 121.538 238.539 109.721 238.539 95.1437C238.539 80.5663 226.722 68.749 212.145 68.749C197.567 68.749 185.75 80.5663 185.75 95.1437C185.75 109.721 197.567 121.538 212.145 121.538Z",
    fill: "url(#paint7_linear_6095_172455)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M187.814 94.1296C187.809 94.1296 187.804 94.1296 187.799 94.1293C187.646 94.1212 187.528 93.9899 187.536 93.8363C187.59 92.7993 187.71 91.758 187.894 90.7408C187.921 90.5894 188.065 90.4887 188.218 90.5159C188.369 90.5435 188.47 90.6883 188.443 90.84C188.263 91.8339 188.146 92.8519 188.093 93.8652C188.085 94.0141 187.961 94.1296 187.814 94.1296Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M190.38 84.4581C190.338 84.4581 190.295 84.4486 190.255 84.4281C190.117 84.3587 190.062 84.1908 190.132 84.0537C194.352 75.6932 202.787 70.4995 212.145 70.4995C213.638 70.4995 215.133 70.634 216.591 70.8999C216.742 70.9273 216.843 71.0725 216.815 71.2242C216.788 71.3759 216.643 71.4772 216.491 71.4483C215.066 71.1888 213.604 71.0573 212.145 71.0573C202.998 71.0573 194.754 76.1336 190.629 84.3048C190.58 84.402 190.482 84.4581 190.38 84.4581Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M228.515 111.516C237.239 102.792 237.239 88.6472 228.515 79.9231C219.79 71.1989 205.646 71.1989 196.922 79.9231C188.197 88.6472 188.197 102.792 196.922 111.516C205.646 120.24 219.79 120.24 228.515 111.516Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M199.286 90.5657L205.956 95.3786C204.911 96.9515 204.275 98.7726 204.218 100.841L195.711 101.116C195.82 97.1825 197.139 93.5597 199.286 90.5657Z",
    fill: "url(#paint8_linear_6095_172455)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M210.748 91.4816C209.115 92.1132 207.666 93.1852 206.548 94.5633L199.902 89.7443C202.169 86.9113 205.182 84.7763 208.56 83.6633L210.748 91.4816Z",
    fill: "url(#paint9_linear_6095_172455)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M219.303 83.7267L216.825 91.2667C215.98 90.9955 215.074 90.8486 214.125 90.8483C213.278 90.848 212.449 90.9641 211.654 91.1827L209.48 83.3884C211.048 82.9654 212.682 82.7631 214.347 82.809C216.099 82.8575 217.762 83.1781 219.303 83.7267Z",
    fill: "url(#paint10_linear_6095_172455)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M227.152 89.8519L221.141 94.3904C220.25 93.1735 219.06 92.202 217.668 91.5876L220.137 84.0505C223.017 85.2636 225.434 87.2981 227.152 89.8519Z",
    fill: "url(#paint11_linear_6095_172455)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M230.021 100.008L222.906 100.238C222.959 98.2955 222.488 96.603 221.633 95.1475L227.622 90.606C229.231 93.2974 230.118 96.5038 230.021 100.008Z",
    fill: "url(#paint12_linear_6095_172455)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.875 97.7534L218.133 94.426L215.486 100.222L212.875 97.7534Z",
    fill: "url(#paint13_linear_6095_172455)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M216.31 99.4581C216.272 100.846 215.159 102.013 213.813 102.063C212.455 102.114 211.376 101.011 211.415 99.5997C211.454 98.1881 212.595 97.0212 213.953 96.9935C215.298 96.9662 216.349 98.0697 216.31 99.4581Z",
    fill: "url(#paint14_linear_6095_172455)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M213.84 101.068C213.017 101.096 212.364 100.425 212.387 99.5715C212.411 98.7179 213.102 98.0076 213.925 97.9881C214.742 97.9686 215.385 98.6404 215.362 99.4854C215.338 100.331 214.657 101.041 213.84 101.068ZM213.916 98.2887C213.255 98.305 212.699 98.8768 212.68 99.5631C212.661 100.249 213.186 100.79 213.848 100.768C214.506 100.746 215.055 100.175 215.074 99.4938C215.093 98.813 214.575 98.2723 213.916 98.2887Z",
    fill: "url(#paint15_linear_6095_172455)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M111.135 58.8526C126.213 58.8526 138.437 46.6288 138.437 31.5501C138.437 16.4713 126.213 4.24756 111.135 4.24756C96.0558 4.24756 83.832 16.4713 83.832 31.5501C83.832 46.6288 96.0558 58.8526 111.135 58.8526Z",
    fill: "url(#paint16_linear_6095_172455)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M111.133 57.9448C125.71 57.9448 137.528 46.1275 137.528 31.5501C137.528 16.9727 125.71 5.1554 111.133 5.1554C96.5556 5.1554 84.7383 16.9727 84.7383 31.5501C84.7383 46.1275 96.5556 57.9448 111.133 57.9448Z",
    fill: "url(#paint17_linear_6095_172455)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M86.8026 30.536C86.7977 30.536 86.7926 30.536 86.7877 30.5358C86.6338 30.5276 86.5158 30.3963 86.5238 30.2427C86.578 29.2058 86.6985 28.1644 86.8821 27.1473C86.9093 26.9959 87.0533 26.8951 87.206 26.9223C87.3576 26.9498 87.4582 27.0947 87.4308 27.2463C87.2517 28.2403 87.1338 29.2582 87.0807 30.2715C87.073 30.4206 86.9499 30.536 86.8026 30.536Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M89.3685 20.8645C89.3263 20.8645 89.2834 20.8549 89.2431 20.8345C89.1055 20.765 89.0504 20.5973 89.1199 20.46C93.3399 12.0996 101.775 6.90588 111.134 6.90588C112.626 6.90588 114.122 7.04041 115.579 7.30626C115.731 7.33372 115.831 7.4789 115.803 7.6306C115.776 7.7823 115.631 7.88353 115.479 7.85466C114.055 7.59513 112.593 7.46362 111.134 7.46362C101.987 7.46362 93.7424 12.5399 89.6176 20.7112C89.5687 20.8083 89.4705 20.8645 89.3685 20.8645Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M127.503 47.9223C136.227 39.1981 136.227 25.0534 127.503 16.3292C118.779 7.60498 104.634 7.60498 95.9098 16.3292C87.1856 25.0534 87.1856 39.1981 95.9098 47.9223C104.634 56.6465 118.779 56.6465 127.503 47.9223Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M119.242 42.6036L122.953 42.6493V22.2478L119.242 22.1588V42.6036Z",
    fill: "url(#paint18_linear_6095_172455)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M112.605 42.5218L116.344 42.5678V32.3286L112.605 32.2607V42.5218Z",
    fill: "url(#paint19_linear_6095_172455)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M105.922 42.4393L109.689 42.4858V19.982L105.922 19.8875V42.4393Z",
    fill: "url(#paint20_linear_6095_172455)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1836 42.3564L102.979 42.4031V23.1646L99.1836 23.0765V42.3564Z",
    fill: "url(#paint21_linear_6095_172455)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.779 115.444C134.149 109.852 143.879 110.486 149.471 116.856C149.817 117.251 150.138 117.659 150.435 118.079C150.834 118.643 151.649 118.695 152.096 118.167L153.557 116.44C153.876 116.063 153.884 115.517 153.586 115.123C153.304 114.75 153.008 114.383 152.694 114.026C145.543 105.879 133.096 105.069 124.949 112.22C124.332 112.762 123.759 113.336 123.228 113.935C122.83 114.383 122.882 115.072 123.347 115.45L125.06 116.84C125.493 117.192 126.124 117.141 126.494 116.724C126.892 116.277 127.318 115.848 127.779 115.444Z",
    fill: "url(#paint22_linear_6095_172455)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M120.468 107.116C131.43 97.4934 148.176 98.5833 157.798 109.545C157.801 109.549 157.804 109.552 157.806 109.555C158.227 110.035 158.971 110.039 159.384 109.551L160.817 107.858C160.813 107.334 160.81 106.996 160.806 106.472C149.591 93.9608 130.296 92.7813 117.638 103.892C116.534 104.862 115.52 105.897 114.591 106.982C114.213 107.424 114.286 108.095 114.737 108.461L116.445 109.847C116.88 110.201 117.521 110.153 117.886 109.728C118.675 108.811 119.533 107.936 120.468 107.116Z",
    fill: "url(#paint23_linear_6095_172455)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M113.158 98.7874C128.307 85.4899 151.238 86.6182 165.036 101.057C165.469 101.511 166.194 101.501 166.599 101.022L168.021 99.3416C168.366 98.9336 168.353 98.3244 167.982 97.9402C152.592 81.999 127.154 80.7945 110.328 95.5636C108.747 96.9511 107.305 98.4367 105.987 99.9974C105.612 100.442 105.685 101.113 106.137 101.48L107.842 102.865C108.287 103.225 108.933 103.156 109.303 102.719C110.474 101.335 111.755 100.018 113.158 98.7874Z",
    fill: "url(#paint24_linear_6095_172455)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138.448 131.097C142.415 131.097 145.631 127.882 145.631 123.915C145.631 119.948 142.415 116.732 138.448 116.732C134.481 116.732 131.266 119.948 131.266 123.915C131.266 127.882 134.481 131.097 138.448 131.097Z",
    fill: "url(#paint25_linear_6095_172455)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M129.373 114.167C135.743 108.576 145.473 109.209 151.065 115.579C151.411 115.974 151.732 116.383 152.029 116.802C152.428 117.367 153.243 117.418 153.69 116.89L155.151 115.163C155.47 114.787 155.477 114.241 155.18 113.847C154.898 113.473 154.602 113.107 154.288 112.75C147.137 104.603 134.69 103.792 126.543 110.944C125.925 111.485 125.353 112.059 124.822 112.658C124.424 113.107 124.476 113.796 124.941 114.174L126.654 115.564C127.087 115.916 127.717 115.864 128.088 115.447C128.485 115.001 128.912 114.572 129.373 114.167Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M122.062 105.839C133.024 96.2171 149.77 97.307 159.392 108.269C159.395 108.272 159.397 108.275 159.4 108.279C159.821 108.759 160.565 108.762 160.977 108.275L162.41 106.581C162.406 106.057 162.404 105.72 162.4 105.196C151.184 92.6845 131.89 91.505 119.232 102.615C118.127 103.585 117.114 104.62 116.185 105.706C115.807 106.148 115.88 106.819 116.331 107.185L118.039 108.571C118.474 108.924 119.115 108.876 119.48 108.452C120.269 107.535 121.127 106.66 122.062 105.839Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.751 97.511C129.901 84.2134 152.832 85.3418 166.629 99.781C167.063 100.234 167.788 100.225 168.193 99.7461L169.615 98.0652C169.96 97.6572 169.947 97.0481 169.576 96.6638C154.186 80.7226 128.747 79.5182 111.922 94.2872C110.341 95.6748 108.899 97.1603 107.581 98.721C107.206 99.1658 107.278 99.8363 107.73 100.203L109.436 101.588C109.881 101.949 110.526 101.879 110.897 101.442C112.068 100.059 113.349 98.742 114.751 97.511Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M142.128 129.511C145.924 128.362 148.07 124.352 146.921 120.555C145.771 116.758 141.761 114.612 137.964 115.762C134.168 116.912 132.022 120.921 133.171 124.718C134.321 128.515 138.331 130.661 142.128 129.511Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5436 90.6659C21.7334 91.0645 19.889 91.8672 19.1243 92.9572C15.6744 97.8741 19.8528 105.538 21.1204 110.481C23.298 118.972 23.5592 128.027 20.8811 136.436C17.9793 145.547 15.9104 154.591 16.2419 164.242C16.4127 169.214 17.3738 174.562 20.2134 178.78C25.5798 186.75 41.166 184.057 44.8078 175.993C47.7123 169.563 47.4234 162.25 46.2925 155.453C44.3898 144.02 40.6567 132.991 38.6815 121.575C37.171 112.846 39.5729 95.9527 29.8628 91.2973C28.087 90.446 25.4641 90.2431 23.5436 90.6659Z",
    fill: "#91B3FA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0283 197.2C28.98 197.2 28.9307 197.192 28.8824 197.177C28.6307 197.096 28.4917 196.827 28.5724 196.575C37.6198 168.313 35.9613 142.016 32.9769 124.932C29.7438 106.424 24.3092 94.4641 24.2547 94.3455C24.1444 94.1052 24.2497 93.8211 24.49 93.7107C24.729 93.6004 25.0144 93.7054 25.1248 93.9457C25.1796 94.0655 30.6658 106.139 33.9199 124.767C36.9227 141.957 38.5908 168.419 29.4841 196.867C29.419 197.07 29.2308 197.2 29.0283 197.2Z",
    fill: "#7D97F4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4195 174.159C21.7488 169.334 18.4964 164.532 16.2087 159.899C14.9991 157.45 14.0333 154.949 13.6754 152.225C13.3195 149.517 13.7036 146.36 11.8182 144.117C8.01956 139.598 3.3556 143.554 1.44268 148.374C-0.77704 153.967 0.448809 161.665 0.788809 167.772C0.993809 171.453 0.811546 175.346 1.42183 178.978C2.43287 184.996 4.94287 188.636 8.52852 190.533C11.9678 192.353 16.1852 191.689 18.9046 188.906C21.3612 186.392 23.5014 181.942 22.4195 174.159Z",
    fill: "#7D97F4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4563 199.526C16.2793 199.526 16.1091 199.427 16.0263 199.258C15.8957 198.991 2.99469 172.311 5.41073 147.105C5.43601 146.841 5.66969 146.648 5.93299 146.674C6.19601 146.699 6.38894 146.933 6.36365 147.196C3.97318 172.136 16.7565 198.572 16.8857 198.836C17.0022 199.074 16.9041 199.361 16.6667 199.477C16.5986 199.51 16.527 199.526 16.4563 199.526Z",
    fill: "#91B3FA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0703 227.378C77.0703 221.443 72.2592 216.632 66.3243 216.632H61.9687C56.0338 216.632 51.2227 221.443 51.2227 227.378V255.986C51.2227 261.92 56.0338 266.732 61.9687 266.732H66.3243C72.2592 266.732 77.0703 261.921 77.0703 255.986V227.378Z",
    fill: "url(#paint26_linear_6095_172455)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M224.496 227.378C224.496 221.443 219.685 216.632 213.75 216.632H209.394C203.46 216.632 198.648 221.443 198.648 227.378V255.986C198.648 261.921 203.46 266.732 209.394 266.732H213.75C219.685 266.732 224.496 261.921 224.496 255.986V227.378Z",
    fill: "url(#paint27_linear_6095_172455)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3369 173.745C65.0148 173.673 64.624 173.388 64.624 173.058V170.85C64.624 168.722 63.587 166.775 61.6868 165.817C59.2354 164.582 56.4334 164.539 53.9462 165.7L49.3706 167.838C47.19 168.857 45.7969 171.046 45.7969 173.453V175.136C45.7969 178.236 48.1268 180.859 51.1978 181.277L70.0353 183.839L72.2917 175.268L65.3369 173.745Z",
    fill: "url(#paint28_linear_6095_172455)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M211.818 173.745C212.14 173.673 212.051 173.388 212.051 173.058V170.85C212.051 168.722 213.567 166.775 215.468 165.817C217.919 164.582 220.961 164.539 223.448 165.7L227.983 167.838C230.164 168.857 231.517 171.046 231.517 173.453V175.136C231.517 178.236 229.347 180.859 226.276 181.277L207.518 183.839L205.062 175.268L211.818 173.745Z",
    fill: "url(#paint29_linear_6095_172455)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M225.883 192.693C223.159 183.498 209.083 174.832 209.083 174.832C209.083 174.832 197.277 138.451 184.564 138.451C174.355 138.451 149.841 138.451 140.576 138.451C140.576 138.451 139.217 138.451 136.943 138.451C127.668 138.451 103.11 138.451 92.8995 138.451C80.1858 138.451 68.3804 174.832 68.3804 174.832C68.3804 174.832 54.3045 183.417 51.5802 192.612C49.5885 199.335 53.9066 225.095 56.373 238.438C57.2426 243.142 61.6815 246.628 66.8651 246.628H136.943H140.576H210.598C215.782 246.628 220.221 243.182 221.09 238.478C223.557 225.135 227.875 199.416 225.883 192.693Z",
    fill: "url(#paint30_linear_6095_172455)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M224.114 231.283C223.322 230.376 222.114 229.715 220.835 229.715H56.6271C55.3564 229.715 54.1547 230.37 53.362 231.267C52.5692 232.163 52.2715 233.403 52.5532 234.522L55.2404 245.084C55.6726 246.801 57.3637 247.904 59.3143 247.904H218.013C219.947 247.904 221.628 246.855 222.077 245.156L224.899 234.488C225.196 233.365 224.906 232.189 224.114 231.283Z",
    fill: "url(#paint31_linear_6095_172455)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3806 214.753C94.3806 214.753 90.2941 202.493 85.148 201.434C80.002 200.374 58.2073 195.834 57.7532 199.617C57.2992 203.401 52.9099 216.418 65.9262 217.628C78.9426 218.839 96.4774 219.835 94.3806 214.753Z",
    fill: "url(#paint32_linear_6095_172455)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M183.078 214.753C183.078 214.753 187.165 202.493 192.311 201.434C197.457 200.374 219.251 195.834 219.705 199.618C220.16 203.401 224.549 216.418 211.532 217.628C198.516 218.839 180.981 219.836 183.078 214.753Z",
    fill: "url(#paint33_linear_6095_172455)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M180.148 204.125C179.725 203.473 179.001 202.91 178.225 202.91H99.2417C98.4374 202.91 97.6919 203.502 97.2773 204.191C96.8627 204.88 96.8396 205.821 97.2164 206.532L101.66 215C103.309 218.109 106.541 220.142 110.061 220.142H168.094C171.848 220.142 175.25 217.888 176.778 214.46L180.318 206.414C180.635 205.705 180.57 204.776 180.148 204.125Z",
    fill: "url(#paint34_linear_6095_172455)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M201.655 177.987C201.142 178.768 200.27 179.296 199.33 179.296H78.1333C77.1842 179.296 76.2989 178.755 75.7904 177.951C75.2818 177.147 75.2182 176.112 75.6269 175.249C78.3785 169.451 83.5411 158.703 86.4335 152.695C86.5652 152.423 86.7104 152.174 86.8739 151.925C88.2724 149.704 90.7288 148.343 93.3942 148.343H185.046C187.738 148.343 190.204 149.725 191.598 151.963C191.793 152.281 191.97 152.604 192.12 152.949L201.873 175.335C202.25 176.193 202.168 177.202 201.655 177.987Z",
    fill: "url(#paint35_linear_6095_172455)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M191.599 151.963C185.178 153.23 166.312 156.377 137.857 156.377C109.165 156.377 92.3282 153.171 86.875 151.922C88.2735 149.702 90.7299 148.343 93.3953 148.343H185.047C187.739 148.343 190.205 149.725 191.599 151.963Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M92.4288 198.075C92.3166 198.075 92.2045 198.034 92.1166 197.951L76.4075 183.086C76.2255 182.913 76.2175 182.626 76.3898 182.444C76.5627 182.262 76.85 182.254 77.0318 182.426L92.741 197.292C92.923 197.464 92.931 197.751 92.7587 197.934C92.6694 198.028 92.5492 198.075 92.4288 198.075Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M183.876 198.075C183.756 198.075 183.635 198.028 183.546 197.934C183.374 197.751 183.382 197.464 183.564 197.291L199.273 182.426C199.455 182.254 199.743 182.261 199.915 182.443C200.087 182.626 200.079 182.913 199.897 183.086L184.188 197.951C184.1 198.034 183.988 198.075 183.876 198.075Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M138.777 155.568C140.538 155.568 141.965 154.141 141.965 152.38C141.965 150.62 140.538 149.193 138.777 149.193C137.017 149.193 135.59 150.62 135.59 152.38C135.59 154.141 137.017 155.568 138.777 155.568Z",
    fill: "url(#paint36_linear_6095_172455)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7713 107.699C77.85 107.699 90.0738 95.4756 90.0738 80.3969C90.0738 65.3181 77.85 53.0944 62.7713 53.0944C47.6925 53.0944 35.4688 65.3181 35.4688 80.3969C35.4688 95.4756 47.6925 107.699 62.7713 107.699Z",
    fill: "url(#paint37_linear_6095_172455)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7697 106.792C77.3471 106.792 89.1644 94.9743 89.1644 80.3969C89.1644 65.8195 77.3471 54.0022 62.7697 54.0022C48.1923 54.0022 36.375 65.8195 36.375 80.3969C36.375 94.9743 48.1923 106.792 62.7697 106.792Z",
    fill: "url(#paint38_linear_6095_172455)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.4393 79.3827C38.4344 79.3827 38.4293 79.3827 38.4244 79.3824C38.2705 79.3743 38.1525 79.243 38.1605 79.0894C38.2148 78.0524 38.3353 77.0111 38.5188 75.994C38.5461 75.8425 38.6901 75.7418 38.8427 75.769C38.9943 75.7965 39.0949 75.9414 39.0675 76.093C38.8884 77.087 38.7705 78.1049 38.7174 79.1183C38.7097 79.2673 38.5867 79.3827 38.4393 79.3827Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M41.0052 69.7113C40.963 69.7113 40.9202 69.7017 40.8798 69.6813C40.7423 69.6118 40.6871 69.4441 40.7566 69.3068C44.9766 60.9464 53.4117 55.7527 62.7703 55.7527C64.2627 55.7527 65.7585 55.8872 67.2157 56.1531C67.3672 56.1805 67.4677 56.3257 67.4402 56.4774C67.4126 56.6291 67.2679 56.7303 67.1158 56.7015C65.6914 56.4419 64.2294 56.3104 62.7703 56.3104C53.6235 56.3104 45.3791 61.3867 41.2543 69.558C41.2054 69.6551 41.1072 69.7113 41.0052 69.7113Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M79.1397 96.7685C87.8639 88.0443 87.8639 73.8996 79.1397 65.1754C70.4155 56.4512 56.2708 56.4512 47.5466 65.1754C38.8224 73.8996 38.8224 88.0443 47.5466 96.7685C56.2707 105.493 70.4155 105.493 79.1397 96.7685Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6133 76.6123L67.7546 72.1218L69.0876 73.3513L64.9463 77.8417L63.6133 76.6123Z",
    fill: "url(#paint39_linear_6095_172455)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1295 80.3907L55.9883 84.8812L57.3213 86.1106L61.4626 81.6201L60.1295 80.3907Z",
    fill: "url(#paint40_linear_6095_172455)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5664 68.0863L76.1953 65.2358L79.0458 67.8647L76.4169 70.7153L73.5664 68.0863Z",
    fill: "url(#paint41_linear_6095_172455)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2539 65.0298L72.8829 62.1792L75.7333 64.8081L73.1045 67.6586L70.2539 65.0298Z",
    fill: "url(#paint42_linear_6095_172455)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3516 71.5725L72.9805 68.722L75.831 71.3509L73.2021 74.2015L70.3516 71.5725Z",
    fill: "url(#paint43_linear_6095_172455)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0391 68.5159L69.6679 65.6654L72.5185 68.2943L69.8896 71.1448L67.0391 68.5159Z",
    fill: "url(#paint44_linear_6095_172455)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1367 75.0587L69.7656 72.2081L72.6162 74.837L69.9873 77.6876L67.1367 75.0587Z",
    fill: "url(#paint45_linear_6095_172455)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8242 72.0021L66.4531 69.1515L69.3036 71.7805L66.6747 74.6309L63.8242 72.0021Z",
    fill: "url(#paint46_linear_6095_172455)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2344 86.8799L58.8633 84.0293L61.7138 86.6583L59.0849 89.5087L56.2344 86.8799Z",
    fill: "url(#paint47_linear_6095_172455)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9219 83.8232L55.5507 80.9727L58.4013 83.6016L55.7724 86.4521L52.9219 83.8232Z",
    fill: "url(#paint48_linear_6095_172455)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0195 90.3661L55.6484 87.5155L58.4989 90.1444L55.87 92.9949L53.0195 90.3661Z",
    fill: "url(#paint49_linear_6095_172455)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M49.707 87.3094L52.3359 84.4589L55.1865 87.0877L52.5576 89.9383L49.707 87.3094Z",
    fill: "url(#paint50_linear_6095_172455)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8047 93.8522L52.4337 91.0017L55.2841 93.6306L52.6553 96.4811L49.8047 93.8522Z",
    fill: "url(#paint51_linear_6095_172455)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4922 90.7955L49.1211 87.9451L51.9716 90.5739L49.3427 93.4244L46.4922 90.7955Z",
    fill: "url(#paint52_linear_6095_172455)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5469 74.8362L57.383 68.5079L70.4933 80.5989L64.6571 86.9271L51.5469 74.8362Z",
    fill: "url(#paint53_linear_6095_172455)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6852 84.7836C66.6952 86.9414 66.8313 90.3037 68.989 92.2937L76.1952 84.4799C74.0375 82.49 70.6752 82.6259 68.6852 84.7836Z",
    fill: "url(#paint54_linear_6095_172455)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1406 86.738L70.7499 86.0774L75.0907 90.0808L74.4815 90.7414L70.1406 86.738Z",
    fill: "url(#paint55_linear_6095_172455)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 91.4619C73.6281 91.005 73.5968 90.2331 74.0537 89.7376C74.5106 89.2422 75.2826 89.211 75.778 89.6678C76.2733 90.1247 76.3046 90.8966 75.8478 91.3921C75.3909 91.8876 74.6189 91.9188 74.1234 91.4619Z",
    fill: "url(#paint56_linear_6095_172455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6095_172455",
    x1: 298.162,
    y1: 346.039,
    x2: 63.1178,
    y2: 54.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6095_172455",
    x1: 132.039,
    y1: 219.684,
    x2: 111.729,
    y2: 401.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6095_172455",
    x1: 180.713,
    y1: 1.55407,
    x2: 180.713,
    y2: 55.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6095_172455",
    x1: 200.665,
    y1: 8.19012,
    x2: 92.3745,
    y2: 171.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6095_172455",
    x1: 189.968,
    y1: 19.6382,
    x2: 152.826,
    y2: 71.2384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6095_172455",
    x1: 192.009,
    y1: 20.8176,
    x2: 154.695,
    y2: 72.6559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6095_172455",
    x1: 213.895,
    y1: 55.3573,
    x2: 211.342,
    y2: 113.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6095_172455",
    x1: 232.098,
    y1: 64.9993,
    x2: 123.808,
    y2: 228.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6095_172455",
    x1: 208.593,
    y1: 74.1827,
    x2: 189.32,
    y2: 131.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6095_172455",
    x1: 210.65,
    y1: 74.8793,
    x2: 191.378,
    y2: 131.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6095_172455",
    x1: 216.676,
    y1: 76.9182,
    x2: 197.403,
    y2: 133.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6095_172455",
    x1: 225.975,
    y1: 80.0654,
    x2: 206.703,
    y2: 137.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6095_172455",
    x1: 231.16,
    y1: 81.8208,
    x2: 211.887,
    y2: 138.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6095_172455",
    x1: 221.446,
    y1: 78.5329,
    x2: 202.173,
    y2: 135.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6095_172455",
    x1: 221.018,
    y1: 78.3885,
    x2: 201.745,
    y2: 135.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6095_172455",
    x1: 221.028,
    y1: 78.3924,
    x2: 201.756,
    y2: 135.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6095_172455",
    x1: 111.803,
    y1: -4.77601,
    x2: 110.846,
    y2: 47.2383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6095_172455",
    x1: 131.087,
    y1: 1.40571,
    x2: 22.7965,
    y2: 165.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6095_172455",
    x1: 124.741,
    y1: 2.27895,
    x2: 113.352,
    y2: 96.4524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6095_172455",
    x1: 118.81,
    y1: 1.56195,
    x2: 107.422,
    y2: 95.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6095_172455",
    x1: 111.495,
    y1: 0.677008,
    x2: 100.107,
    y2: 94.8503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6095_172455",
    x1: 105.053,
    y1: -0.101936,
    x2: 93.6646,
    y2: 94.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6095_172455",
    x1: 159.892,
    y1: 79.7185,
    x2: 103.891,
    y2: 172.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6095_172455",
    x1: 155.941,
    y1: 77.3235,
    x2: 99.9403,
    y2: 169.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6095_172455",
    x1: 151.999,
    y1: 74.9344,
    x2: 95.9987,
    y2: 167.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6095_172455",
    x1: 163.803,
    y1: 82.09,
    x2: 107.803,
    y2: 174.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6095_172455",
    x1: 64.6131,
    y1: 263.142,
    x2: 63.2468,
    y2: 200.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6095_172455",
    x1: 211.969,
    y1: 259.936,
    x2: 210.603,
    y2: 197.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6095_172455",
    x1: 102.205,
    y1: 24.3616,
    x2: 84.0141,
    y2: 87.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6095_172455",
    x1: 306.551,
    y1: 129.744,
    x2: 271.127,
    y2: 147.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6095_172455",
    x1: 136.488,
    y1: 261.44,
    x2: 139.839,
    y2: 166.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6095_172455",
    x1: 135.989,
    y1: 134.256,
    x2: 137.904,
    y2: 203.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6095_172455",
    x1: 88.2704,
    y1: 122.764,
    x2: 115.078,
    y2: -63.9317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6095_172455",
    x1: 155.905,
    y1: -109.032,
    x2: 129.097,
    y2: -295.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6095_172455",
    x1: 139.165,
    y1: 221.405,
    x2: 141.887,
    y2: 322.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6095_172455",
    x1: 144.507,
    y1: 137.722,
    x2: 155.994,
    y2: 60.6616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6095_172455",
    x1: 138.13,
    y1: 162.261,
    x2: 139.563,
    y2: 140.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6095_172455",
    x1: 64.1238,
    y1: 39.5959,
    x2: 62.2092,
    y2: 97.3544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6095_172455",
    x1: 82.7234,
    y1: 50.2525,
    x2: -25.5668,
    y2: 213.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6095_172455",
    x1: 75.2857,
    y1: 53.7727,
    x2: 35.4262,
    y2: 148.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6095_172455",
    x1: 71.7688,
    y1: 52.2905,
    x2: 31.9092,
    y2: 146.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6095_172455",
    x1: 81.2337,
    y1: 56.2793,
    x2: 41.3743,
    y2: 150.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6095_172455",
    x1: 77.3272,
    y1: 54.6326,
    x2: 37.4677,
    y2: 149.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6095_172455",
    x1: 79.7509,
    y1: 55.6544,
    x2: 39.8914,
    y2: 150.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6095_172455",
    x1: 75.8443,
    y1: 54.0078,
    x2: 35.9848,
    y2: 148.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6095_172455",
    x1: 78.268,
    y1: 55.0295,
    x2: 38.4085,
    y2: 149.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6095_172455",
    x1: 74.3614,
    y1: 53.3829,
    x2: 34.5019,
    y2: 147.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6095_172455",
    x1: 73.2384,
    y1: 52.9109,
    x2: 33.3791,
    y2: 147.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6095_172455",
    x1: 69.3319,
    y1: 51.2643,
    x2: 29.4725,
    y2: 145.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6095_172455",
    x1: 71.7555,
    y1: 52.2859,
    x2: 31.8961,
    y2: 146.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6095_172455",
    x1: 67.849,
    y1: 50.6393,
    x2: 27.9894,
    y2: 145.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6095_172455",
    x1: 70.2727,
    y1: 51.661,
    x2: 30.4131,
    y2: 146.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6095_172455",
    x1: 66.3661,
    y1: 50.0145,
    x2: 26.5067,
    y2: 144.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6095_172455",
    x1: 71.7375,
    y1: 52.2781,
    x2: 31.878,
    y2: 146.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6095_172455",
    x1: 83.7647,
    y1: 57.3437,
    x2: 43.9052,
    y2: 151.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6095_172455",
    x1: 85.4111,
    y1: 58.0378,
    x2: 45.5517,
    y2: 152.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6095_172455",
    x1: 88.1651,
    y1: 59.1991,
    x2: 48.3058,
    y2: 153.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.4e881af9522ae39385d0463b5bfa065d.svg";
export { ForwardRef as ReactComponent };